import queryString from "query-string";

const backendBaseURL = "https://backend.snobify.xyz";

// const backendBaseURL =
//   process.env.NODE_ENV === "production"
//     ? "https://backend.snobify.xyz"
//     : "http://127.0.0.1:8000";

const makeBackendAPIRequest = (params) => {
  const fetchOptions = {
    method: params.method,
    headers: {
      Authorization:
        "Bearer spotify " + localStorage.getItem("spotify_auth_access_token"),
    },
  };

  if (params.body) {
    fetchOptions.body = queryString.stringify(params.body);
    fetchOptions.headers["Content-Type"] = "application/x-www-form-urlencoded";
  }

  fetch(params.url, fetchOptions)
    .then((response) => {
      if (response.status === 500) {
        throw new Error();
      } else {
        return response.json();
      }
    })
    .then((data) => {
      if (data.error) {
        params.onFailureCallback();

        return;
      }
      params.onSuccessCallback(data);
    })
    .catch((err) => {
      if (!params.triesAttempted) {
        params.triesAttempted = 0;
      }
      if (params.triesAttempted < 3) {
        params.triesAttempted += 1;
        setTimeout(() => {
          makeBackendAPIRequest(params);
        }, 2000);
      } else {
        console.error("Backend API request failed:", err);
        params.onFailureCallback();
      }
    });
};

const isIDSpotifyInInfos = (infos, candidateIDSpotify) => {
  return infos.some((info) => info.id_spotify === candidateIDSpotify);
};

const isSpotifyTrackInSongInfos = (
  songInfos,
  spotifyTrackID,
  spotifyTrackName,
  spotifyTrackNumber,
  spotifyTrackDuration,
  trueSongID,
  shouldLink
) => {
  let matchingTrackProperties = false;
  for (const songInfo of songInfos) {
    if (songInfo.id_spotify == spotifyTrackID) {
      return {
        wasTrackFound: true,
        link: null,
      };
    }

    if (
      songInfo.name == spotifyTrackName &&
      songInfo.track_number == spotifyTrackNumber
    ) {
      if (!shouldLink) {
        return {
          wasTrackFound: true,
          link: null,
        };
      }
      matchingTrackProperties = true;
    }
  }

  if (shouldLink && matchingTrackProperties) {
    return {
      wasTrackFound: true,
      link: {
        id_song_spotify: spotifyTrackID,
        id_true_song: trueSongID,
        song_name: spotifyTrackName,
        duration_ms: spotifyTrackDuration,
        track_number: spotifyTrackNumber,
      },
    };
  }

  return {
    wasTrackFound: false,
    link: null,
  };
};

const getTagsFromBackendAlbum = (spotifyTrack, backendAlbum) => {
  const tagsForTrack = [];
  const tag_links = [];
  const tags = backendAlbum.tags ?? [];

  for (const candidateTag of tags) {
    const { wasTrackFound, link } = isSpotifyTrackInSongInfos(
      candidateTag.song_infos,
      spotifyTrack.id,
      spotifyTrack.name,
      spotifyTrack.track_number,
      spotifyTrack.duration_ms,
      candidateTag.song_id,
      true
    );

    if (wasTrackFound) {
      tagsForTrack.push(candidateTag);
      if (link) {
        tag_links.push(link);
      }
    }
  }

  return {
    tags: tagsForTrack,
    tag_links,
  };
};

const getTrackRatingFromBackendAlbum = (spotifyTrack, backendAlbum) => {
  const tracks = backendAlbum.tracks ?? backendAlbum.songs ?? [];

  for (const track of tracks) {
    const { wasTrackFound, link } = isSpotifyTrackInSongInfos(
      track.song_infos,
      spotifyTrack.id,
      spotifyTrack.name,
      spotifyTrack.track_number,
      spotifyTrack.duration_ms,
      track.id,
      true
    );

    if (wasTrackFound) {
      return {
        rating: track.deliberately_unrated ? "-" : track.rating,
        rating_links: link ? [link] : [],
      };
    }
  }

  return {
    rating: "",
    rating_links: [],
  };
};

const linkTracks = (linkObjects) => {
  const dedupeLinks = (arr) => {
    const seen = new Set();
    const out = [];

    for (const o of arr) {
      const key = `${o["id_song_spotify"]}|${o["id_true_song"]}`;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(o);
    }
    return out;
  };

  if (linkObjects.length === 0) {
    return;
  }

  const dedupedLinks = dedupeLinks(linkObjects);
  const url = new URL(backendBaseURL + "/song/link_tracks");

  makeBackendAPIRequest({
    url: url,
    method: "POST",
    body: { links: JSON.stringify(dedupedLinks) },
    onSuccessCallback: () => {},
    onFailureCallback: () => {
      alert(`failed to link ${JSON.stringify(dedupedLinks)}`);
    },
  });
};

export {
  getTrackRatingFromBackendAlbum,
  getTagsFromBackendAlbum,
  linkTracks,
  isIDSpotifyInInfos,
  makeBackendAPIRequest,
  backendBaseURL,
};
